import Modal from "../Modal"
import { StatusBadge } from "./StatusBadge"
import Button from "../Button"

const getNextStatus = (currentStatus) => {
  const statusFlow = {
    'choose-guide': 'invite-student',
    'invite-student': 'sit-with-student',
    'sit-with-student': 'invite-mentors',
    'invite-mentors': 'send-plan',
    'send-plan': 'checklist-complete',
  }
  return statusFlow[currentStatus] || null
}

export const ProgressPlanModal = ({ isOpen, onClose, plan, onConfirm, isProgressing }) => {
  if (!plan) return null

  const nextStatus = getNextStatus(plan.status)

  return (
    <Modal isOpen={isOpen} setIsOpen={onClose} width="md:max-w-xl">
      <div className="flex flex-col gap-6">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-brandSecondary mb-2">
            Progress Plan?
          </h2>
          <p className="text-gray-600">
            This will manually advance the plan to the next status.
          </p>
        </div>

        <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
          <div className="flex items-center justify-center gap-4">
            <div className="text-center">
              <div className="text-sm text-gray-600 mb-2">Current</div>
              <StatusBadge status={plan.status} />
            </div>
            <i className="fa-solid fa-arrow-right text-gray-400 text-2xl"></i>
            <div className="text-center">
              <div className="text-sm text-gray-600 mb-2">Next</div>
              {nextStatus ? (
                <StatusBadge status={nextStatus} />
              ) : (
                <span className="text-gray-400 text-sm">Terminal status</span>
              )}
            </div>
          </div>
        </div>

        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
          <div className="flex gap-2">
            <i className="fa-solid fa-triangle-exclamation text-yellow-600"></i>
            <p className="text-sm text-yellow-800">
              This action will be logged in the progression history as a manual change.
            </p>
          </div>
        </div>

        <div className="flex justify-center gap-4">
          <Button onClick={onClose} variant="gray-ghost" disabled={isProgressing}>
            Cancel
          </Button>
          <Button onClick={onConfirm} variant="default" disabled={isProgressing || !nextStatus}>
            {isProgressing ? 'Progressing...' : 'Confirm Progress'}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
